import { ref, computed } from "vue";

export function usePagination(options = {}) {
  const initialPage = options.initialPage ?? 0;
  const defaultPageSize = options.pageSize ?? 10;
  const baseIndex = options.baseIndex ?? (initialPage === 1 ? 1 : 0);

  const currentPage = ref(initialPage);
  const pageSize = ref(defaultPageSize);
  const totalPages = ref(1);
  const totalElements = ref(0);

  const hasNextPage = computed(() => {
    const maxPage = baseIndex === 0 ? totalPages.value - 1 : totalPages.value;
    return currentPage.value < maxPage;
  });

  const hasPreviousPage = computed(() => {
    return currentPage.value > baseIndex;
  });

  const setPaginationInfo = (response = {}) => {
    if (!response) return;

    if (response.totalPages !== undefined && response.totalPages !== null) {
      totalPages.value = response.totalPages;
    } else if (response.numPag !== undefined && response.numPag !== null) {
      totalPages.value = response.numPag;
    } else if (
      response.page?.totalPages !== undefined &&
      response.page?.totalPages !== null
    ) {
      totalPages.value = response.page.totalPages;
    }

    if (
      response.totalElements !== undefined &&
      response.totalElements !== null
    ) {
      totalElements.value = response.totalElements;
    } else if (response.total !== undefined && response.total !== null) {
      totalElements.value = response.total;
    } else if (
      response.page?.totalElements !== undefined &&
      response.page?.totalElements !== null
    ) {
      totalElements.value = response.page.totalElements;
    } else if (Array.isArray(response)) {
      totalElements.value = response.length;
    }

    if (response.number !== undefined && response.number !== null) {
      currentPage.value = response.number;
    } else if (
      response.page !== undefined &&
      typeof response.page === "number"
    ) {
      currentPage.value = response.page;
    }
  };

  const resetPagination = () => {
    currentPage.value = initialPage;
    totalPages.value = 1;
    totalElements.value = 0;
  };

  const nextPage = async (callback) => {
    if (hasNextPage.value) {
      currentPage.value++;
      if (typeof callback === "function") {
        await callback(currentPage.value, pageSize.value);
      }
    }
  };

  const previousPage = async (callback) => {
    if (hasPreviousPage.value) {
      currentPage.value--;
      if (typeof callback === "function") {
        await callback(currentPage.value, pageSize.value);
      }
    }
  };

  const goToPage = async (page, callback) => {
    const minPage = baseIndex;
    const maxPage = baseIndex === 0 ? totalPages.value - 1 : totalPages.value;
    if (page >= minPage && page <= maxPage) {
      currentPage.value = page;
      if (typeof callback === "function") {
        await callback(currentPage.value, pageSize.value);
      }
    }
  };

  return {
    currentPage,
    pageSize,
    totalPages,
    totalElements,
    totalItems: totalElements,
    hasNextPage,
    hasPreviousPage,
    setPaginationInfo,
    resetPagination,
    nextPage,
    previousPage,
    goToPage,
  };
}
